import React, { FunctionComponent } from 'react';
import { InjectedIntl } from 'react-intl';
import { version } from '../../../package.json';
import { getTextFactory } from 'utils/TextUtils';
import AppVersion from 'components/AppVersion';

export type FooterProps = {
  intl: InjectedIntl;
};

const Footer: FunctionComponent<FooterProps> = (props: FooterProps) => {
  const { intl } = props;

  const getText = getTextFactory(intl, 'global');

  return (
    <div data-test="footer" className="flex justify-between w-full max-md:flex-col max-md:text-center">
      <div className="max-md:mb-2">
        <AppVersion version={version} />
      </div>
      <div data-test="footer-copyright">{getText('copyright')}</div>
    </div>
  );
};

export default Footer;
